/**
 * Movepro CRM API interface
 *
 * @package Movepro CRM
 * @module Company
 */

const ROUTE = '/companies';

async function index() {
    const {
        data: { data: data },
    } = await window.tenantAxios.get(ROUTE);
    console.log('Companies debug', data);
    return data;
}

function create(company) {
    return window.tenantAxios.post(ROUTE, company);
}

function retrieve(id, query) {
    return window.tenantAxios.get(`${ROUTE}/${id}`, {
        params: query,
    });
}

function retrieveWithQuery(id, query) {
    return window.tenantAxios.get(`${ROUTE}/${id}${query ? query : ''}`);
}

function retrieveSettings(id, query = {}) {
    return window.tenantAxios.get(`${ROUTE}/${id}/settings`, { params: query });
}

function update(companyId, company) {
    return window.tenantAxios.patch(`${ROUTE}/${companyId}`, {
        company_id: companyId,
        ...company,
    });
}

function updateSettings(companyId, company) {
    return window.tenantAxios.patch(`${ROUTE}/${companyId}/settings`, {
        company_id: companyId,
        ...company,
    });
}

function destroy(id) {
    return window.tenantAxios.delete(`${ROUTE}/${id}`);
}

// Helper API Services

/**
 * Register a company with associated user record.
 * @route /api/v1/register/company
 * @param {*} company
 * @returns true|false
 */
function register(company) {
    return window.centralAxios.post('/register/company', company);
}

/**
 * Retrieve list of company users
 * @param {*} companyId
 * @returns
 */
function users(companyId) {
    return window.tenantAxios.get(`${ROUTE}/${companyId}/users`);
}

export default {
    index,
    create,
    retrieve,
    update,
    destroy,
    retrieveWithQuery,
    register,
    users,
    retrieveSettings,
    updateSettings,
};
